module.exports = __webpack_public_path__ + "static/media/hand.dd14ea42.svg";